import React from 'react'

export default function BowTie() {
    return <div className='bubble-bow-tie'>
        <img alt="bow-tie" className='bubble-icon-shake' src={process.env.PUBLIC_URL + "/img/bow-tie.png"} width={30}/>
    </div>
}